// @ts-nocheck
import React from 'react';
import PlatformLink from '../../common/links/PlatformLink';
import { useTranslation } from 'react-i18next';

export interface PlatformProps {
  request: Record<string, unknown>;
  compressed?: boolean;
}

const Platform = ({ request, compressed }: PlatformProps) => {
  const { t } = useTranslation();

  return request && compressed ? (
    <PlatformLink name={request.platform} id={request.platformId} />
  ) : (
    <div className="col-6">
      <label className="col-form-label">{t('Platform')}</label>
      <div className="flex ps-0">
        <div className="form-control-static px-3 flex h-100 w-100 align-items-center">
          <PlatformLink name={request.platform} id={request.platformId} />
        </div>
      </div>
    </div>
  );
};

export default Platform;
